<!-- 缺陷分布占比 -->
<template>
  <div>
    <a-card size="small">
      <template slot="title">
        <span style="margin-right: 4px">缺陷分布占比</span>
        <a-popover title="报表说明" placement="topLeft">
          <template slot="content">
            <p>时间：创建时间</p>
            <p>计算方式: 自然日计算</p>
            <p>统计维度: 状态为DONE的非生产缺陷</p>
            <p>描述：所选时间段内各团队或各团队成员基于缺陷数量的分布占比情况</p>
          </template>
          <a-icon type="question-circle" />
        </a-popover>
      </template>
      <div id="issue-num" :style="{ height: height, width: width }" />
    </a-card>
    <a-modal :visible="modalVisible" :footer="null" :title="title" :closable="false" :width="900" @cancel="closeModal">
      <a-table :columns="columns" :data-source="tableData" :width="800">
        <span slot="issueTitle" slot-scope="text, record">
          <a-tooltip placement="top" :title="record.title">
            <a class="custom-link" :href="link(record)" target="_blank">{{ record.title }}</a>
          </a-tooltip>
        </span>
      </a-table>
    </a-modal>
  </div>
</template>
<script>
export default {
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '300px'
    },
    data: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      myChart: null,
      modalVisible: false,
      title: '',
      tableData: [],
      columns: [
        {
          title: 'ID',
          dataIndex: 'id',
          scopedSlots: { customRender: 'id' }
        },
        {
          title: '缺陷标题',
          dataIndex: 'title',
          scopedSlots: { customRender: 'issueTitle' }
        },
        {
          title: '处理人',
          width: 100,
          dataIndex: 'handler',
          scopedSlots: { customRender: 'handler' },
          sorter: (a, b) => a.handler.localeCompare(b.handler)
        }
      ],
      option: {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          top: '5%',
          left: 'center',
          show: false
        },
        series: [
          {
            name: '缺陷总数',
            type: 'pie',
            radius: '60%',
            center: ['50%', '50%'],
            data: [],
            label: {
              formatter: '{b} ({d}%)',
              fontSize: 12
            },
            emphasis: {
              label: {
                show: true,
                fontWeight: 'bold'
              }
            }
          }
        ]
      }
    };
  },
  computed: {
    link() {
      return record => {
        const route = this.$router.resolve({
          name: 'page:project:quality:issue:detail',
          query: { issueId: record.id },
          params: { project_id: record.project_id }
        });
        return route.href;
      };
    }
  },
  watch: {
    data() {
      this.getDiagramData();
    },
    '$store.state.collapsed'() {
      setTimeout(() => {
        this.myChart.resize();
      }, 200);
    }
  },
  mounted() {
    // let echarts = require('echarts');
    const echarts = require('echarts/lib/echarts');
    require('echarts/lib/chart/pie'); // 饼图
    // 下面的是需要的提示框
    require('echarts/lib/component/tooltip');
    require('echarts/lib/component/legend');
    this.myChart = echarts.init(document.getElementById('issue-num'));
    this.myChart.on('click', params => {
      this.tableData = this.data[params.dataIndex].issues_detail;
      this.modalVisible = true;
      this.title = params.data.name + '(' + this.data[params.dataIndex].issue_count + '个' + ')';
    });
    setTimeout(() => {
      this.getDiagramData();
    }, 100); // 添加延迟
  },
  beforeDestroy() {
    /* 页面组件销毁的时候，移除绑定的监听resize事件，防止内存泄漏和额外CPU或GPU占用*/
    window.removeEventListener('resize', () => {
      this.myChart.resize();
    });
  },
  methods: {
    drawChart() {
      this.myChart.setOption(this.option);
      window.addEventListener('resize', () => {
        this.myChart.resize();
      });
    },
    closeModal() {
      this.modalVisible = false;
    },
    getDiagramData() {
      this.option.series[0].data = []; // 清空原有数据
      this.data.forEach(el => {
        this.option.series[0].data.push(
          {
            value: el.issue_count,
            name: el.team_name
          }
        );
      });
      this.drawChart();
    }
  }
};
</script>
